import { render, staticRenderFns } from "./block-member-info.vue?vue&type=template&id=f2078c46&scoped=true&"
import script from "./block-member-info.vue?vue&type=script&lang=js&"
export * from "./block-member-info.vue?vue&type=script&lang=js&"
import style0 from "./block-member-info.vue?vue&type=style&index=0&id=f2078c46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2078c46",
  null
  
)

export default component.exports